import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";

export const promotionChannelListQuery = graphql(`
  query PromotionChannelList(
    $first: Int!
    $page: Int
    $supplier_id: ID
    $status: [PromotionStatus!]
    $wherePromotion: QueryPromotionChannelsWherePromotionWhereHasConditions
    $orderBy: [QueryPromotionChannelsOrderByOrderByClause!]
  ) {
    promotionChannels(
      first: $first
      page: $page
      supplier_id: $supplier_id
      status: $status
      wherePromotion: $wherePromotion
      orderBy: $orderBy
    ) {
      data {
        id
        platform
        status
        budget_amount
        impressions
        clicks
        conversions
        spend_amount
        last_synced_at
        created_at
        manager_url
        promotion {
          id
          budget_amount
          creative {
            title
            body
            target_url
            image_url
          }
          relocation {
            id
            name
            reference
          }
        }
      }
      paginatorInfo {
        ...PaginationFields
      }
    }
  }
`);

export type PromotionChannelListItem = NonNullable<
  ResultOf<typeof promotionChannelListQuery>["promotionChannels"]
>["data"][number];
